import React from 'react'
import { NavLink } from 'react-router-dom'
import Pagination from '../../../../../Pagination/Pagination'
import { connect } from 'react-redux'

const AdminStoreProductsList = (props, {user}) => {
    const storeId = props.storeId
    const ProductList = props.ProductList
    const TotalProducts = props.TotalProducts
    const formatter = props.formatter
    const numberFormatter = props.numberFormatter
    const PageSize = props.PageSize
    const ProductInfo = props.ProductInfo
    const WarehouseDetails = props.WarehouseDetails
    return (
        <>
            
            <div className="card mb-0">
                <div className="card-body">
                    <div className="card-header pb-0 d-flex justify-content-between align-items-center">
                        <h4 className="card-title">Product List</h4>
                        <div className="graph-sets">
                            <div className="dropdown px-1 w-50">
                                <label htmlFor="pageSize" className="form-label">Per Page</label>
                                <select className="form-select" id="pageSize" value={PageSize} onChange={(e)=>{props.onPageSizeChange(e)}} aria-label="Range">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            <div className="dropdown px-1 w-50">
                                <label htmlFor="pageSize" className="form-label">Sort By</label>
                                <select className="form-select" id="customFilter" value={props.OrderBy} onChange={(e)=>{props.onCustomOrderByChange(e)}}  aria-label="Range">
                                    <option value="title">Title</option>
                                    <option value="sales">Sales (In last 21 days)</option>
                                    <option value="buyBox">BuyBox</option>
                                    <option value="selling_price">Price</option>
                                    <option value="total_cost_per_unit">Cost</option>
                                    <option value="-title">Desc. Title</option>
                                    <option value="-sales">Desc. Sales (In last 21 days)</option>
                                    <option value="-buyBox">Desc. BuyBox</option>
                                    <option value="-selling_price">Desc. Price</option>
                                    <option value="-total_cost_per_unit">Desc. Cost</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive text-wrap">
                        <table className="table mb-0">
                            <thead>
                                
                                <tr>
                                    <th>
                                        Title 
                                    </th>
                                    <th >
                                        View on Takealot
                                    </th>
                                    <th>
                                        BuyBox
                                        {/* <select className="form-select" name='buyboxStatus' value={props.StatusFilters['buyboxStatus']} onChange={(e)=>{props.onStatusFilterChange(e)}} id='buyboxStatus' aria-label="Default select example">
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                            <option value="2">Eligible</option>
                                            <option value="3">Ineligible</option>
                                            <option value="All">All</option>
                                        </select> */}
                                    </th>
                                    <th >
                                        Price
                                        
                                    </th>
                                    <th >
                                        U.O.                                                             
                                        
                                    </th>
                                    <th >
                                        CPU                                       
                                        
                                    </th>
                                    <th >
                                        SPU                                           
                                        
                                    </th>
                                    <th >
                                        SpPU  
                                    </th>
                                    <th >
                                        Cost
                                    </th>
                                    <th>
                                        Status
                                        <select className="form-select" name='status' value={props.StatusFilters['status']} onChange={(e)=>{props.onStatusFilterChange(e)}} id='statusFilter' aria-label="Default select example">
                                            <option value="All">All</option>
                                            <option value="Buyable">Buyable</option>
                                            <option value="Not Buyable">Not Buyable</option>
                                            <option value="Disabled by Seller">Disabled By Seller</option>
                                        </select>
                                    </th>
                                    <th >Level</th>
                                    <th >
                                        Total
                                    </th>
                                    <th >
                                        CPT
                                    </th>
                                    <th >
                                        JHB
                                    </th>
                                    {/* <th>LT Stock</th>
                                    <th>LT Days</th>
                                    <th>Past month</th>
                                    <th>Past year</th>
                                    <th>Total</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    ProductList.map(
                                        (row, index)=>{
                                        return(
                                            <>
                                            <tr key={index}>
                                                <td>
                                                    <img src={row.image_url} alt="Avatar" className="rounded-circle avatar avatar-md pull-up" />
                                                    <button style={{border: 'none', backgroundColor : 'transparent'}} >{row.title.substring(0, 45)}...</button>
                                                    
                                                {/* <NavLink to={{pathname:"/product"}} state={{sku : row.sku}}>
                                                    {row.title}
                                                </NavLink> */}
                                                </td>
                                                <td>
                                                    <a href={row?.offer_url} target='_blank' style={{color: 'white'}} className={"btn btn-primary me-1 bg-label-success"}>
                                                        <span>Takealot Link</span>
                                                    </a>
                                                </td>
                                                <td>
                                                    <div className='row'>
                                                        <div className='col-8'>
                                                            <span>
                                                                {
                                                                    row.buyBox === 1 ? 
                                                                    <>
                                                                        <span>Active</span>
                                                                    </>: row.buyBox === 0 ?
                                                                    <>  
                                                                        <span>Inactive</span>
                                                                    </> : row.buyBox === 2 ?
                                                                    <>  
                                                                        <span>Eligible</span>
                                                                    </> :  row.buyBox === 3 ?
                                                                    <>  
                                                                        <span>Ineligible</span>
                                                                    </> :
                                                                    <>
                                                                        <span>Not Buyable</span>
                                                                    </>
                                                                }
                                                            </span>
                                                        </div>
                                                        {/* <div className='col-4'>
                                                            {
                                                                row.buyBox === 1 || row.buyBox === 0 ?
                                                                <div className="form-check form-switch form-switch-xl mb-2">
                                                                    <input className="form-check-input form-switch-xl" type="checkbox" id="flexSwitchCheckChecked" checked={row.status === 1 ? true : false}/>
                                                                </div>
                                                                : <></>
                                                            }
                                                        </div> */}
                                                    </div>
                                                </td>
                                                <td>
                                                    {formatter.format(row.selling_price)}
                                                </td>
                                                <td>
                                                <span value={numberFormatter.format(row.total_units_ordered)}>{numberFormatter.format(row.total_units_ordered)}</span>
                                                </td>
                                                <td>
                                                <span value={numberFormatter.format(row.cost_per_unit)}>{formatter.format(row.cost_per_unit)}</span>
                                                </td>
                                                <td>
                                                <span value={numberFormatter.format(row.storage_cost_per_unit)}>{formatter.format(row.storage_cost_per_unit)}</span>
                                                </td>
                                                <td>
                                                <span value={numberFormatter.format(row.shipment_cost_per_unit)}>{formatter.format(row.shipment_cost_per_unit)}</span>
                                                </td>
                                                <td>
                                                <span value={numberFormatter.format(row.total_cost_per_unit)}>{formatter.format(row.total_cost_per_unit)}</span>
                                                </td>
                                                <td>
                                                {
                                                    row.status === "Buyable" ? 
                                                    <span className="bg-label-primary ">
                                                    {row.status}
                                                    </span> :
                                                    row.status === "Not Buyable" ? 
                                                    <span className="bg-label-danger ">
                                                    {row.status}
                                                    </span>
                                                    :
                                                    <span className="bg-label-secondary ">
                                                    {row.status}
                                                    </span>
                                                }
                                                </td>
                                                <td>
                                                {row.stock_at_takealot_total ? Number(row.stock_at_takealot_total) > 0 ?
                                                    <>
                                                    <span className="bg-label-primary ">
                                                        Stock
                                                    </span>
                                                    </>
                                                    
                                                    : 
                                                    <span className="bg-label-danger ">
                                                    No Stock
                                                    </span> : <></>
                                                    }
                                                </td>
                                                <td>{numberFormatter.format(row.stock_at_takealot_total)}</td>
                                                <td>{numberFormatter.format(row.CPT)}</td>
                                                <td>{numberFormatter.format(row.JHB)}</td>
                                                {/* <th>{numberFormatter.format(row.total_leadtime_stock)}</th>
                                                <th>{row.leadtime_days ? numberFormatter.format(row.leadtime_days) : 0}</th>
                                                <th>{formatter.format(row.lastMonthSales)}</th>
                                                <th>{formatter.format(row.lastYearSales)}</th>
                                                <th>{formatter.format(row.totalSales)}</th> */}
                                            </tr>
                                            </>
                                        )
                                        })
                                    }
                            </tbody>
                        </table>
                        <br/>
                        <div className='pagination justify-content-center'>
                            {
                                TotalProducts > 0 ?
                                    <Pagination totalPages={props.TotalPages} totalRecords={TotalProducts} pageLimit={PageSize} paginationFilters={props.StatusFilters} paginationSearchQuery={props.SearchQuery} paginationPageSize={props.PageSize} accountId={props.user.id} dashboard={storeId} paginationOrderBy={props.OrderBy} onPageChanged={props.loadProductList} />                                    
                                    // <Pagination  totalRecords={TotalProducts} pageLimit={props.PageSize} paginationFilters={props.StatusFilters} paginationSearchQuery={props.SearchQuery} accountId={props.user.id} dashboard={1} paginationOrderBy={props.OrderBy} onPageChanged={props.loadProductList} />
                                : <></>
                            }
                        </div>
                    </div>
                </div>
            </div>
            
            
        </>
    )
}

const mapStateToProps = state => ({
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user,
})

export default connect(mapStateToProps)(AdminStoreProductsList)